import { useState } from 'react';
import { Box, Button } from "@chakra-ui/react";
import { MdAdsClick } from 'react-icons/md';
import ToolsDrawer from '@/components/tools-drawer';

export default function MapTools() {
  const [isOpen, setIsOpen] = useState(false);

  const onToggleTools = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Box 
      display={{ base: 'flex', lg: 'none' }}
      position='absolute'
      bottom='calc(env(safe-area-inset-bottom, 0px) + 1rem)'
      right='calc(env(safe-area-inset-right, 0px) + 1rem)'
      zIndex={1000}
      pointerEvents='auto'
    >
      <ToolsDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} />

      <Button
        aria-label='Map Tools'
        onClick={onToggleTools}
        size='lg'
        color='white'
        backgroundColor='#2f4050'
        variant='solid'
        boxShadow='lg'
        borderRadius='full'
        _hover={{ backgroundColor: '#1a252f' }}
      >
        <MdAdsClick /> Map Tools
      </Button>
    </Box>
  )
}